import { addStyles } from './index.es.js';

var tiny = "mc27e146e9_tiny";
var circle = "mc27e146e9_circle";
var pill = "mc27e146e9_pill";
var styles = ".mc27e146e9_tiny{font-size:18px;line-height:29px}.mc27e146e9_tiny,.mc27e146e9_tiny:after,.mc27e146e9_tiny:before{border-radius:16px}.mc27e146e9_tiny:focus:before{border-radius:29px}.mc27e146e9_circle{align-items:center;display:flex;height:32px;justify-content:center;padding:0;text-align:center;width:32px}.mc27e146e9_pill{max-height:32px;padding:0 20px}";

addStyles([{
  attributeName: 'size',
  attributeValue: 'tiny',
  className: tiny,
  styles: styles,
  variations: {
    circle: circle,
    pill: pill
  }
}]);
